"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.playerReceiveQuickChatEvent = exports.playerReceiveQuickChatEventSchema = exports.quickChatPlayerAction = exports.quickChatPlayerActionSchema = exports.getQuickChatOptions = exports.FinishedQuickChatOptions = exports.ReadyQuickChatOptions = void 0;
const api_1 = require("@cc-plugins/api");
const zod_1 = require("zod");
const game_phase_1 = require("../game-phase");
var ReadyQuickChatOptions;
(function (ReadyQuickChatOptions) {
    ReadyQuickChatOptions["GL"] = "GL";
    ReadyQuickChatOptions["HAPPY"] = "\uD83D\uDE03";
    ReadyQuickChatOptions["SHOCKED"] = "\uD83D\uDE31";
    ReadyQuickChatOptions["ANGRY"] = "\uD83D\uDE20";
})(ReadyQuickChatOptions || (exports.ReadyQuickChatOptions = ReadyQuickChatOptions = {}));
var FinishedQuickChatOptions;
(function (FinishedQuickChatOptions) {
    FinishedQuickChatOptions["GG"] = "GG";
    FinishedQuickChatOptions["HAPPY"] = "\uD83D\uDE03";
    FinishedQuickChatOptions["SHOCKED"] = "\uD83D\uDE31";
    FinishedQuickChatOptions["ANGRY"] = "\uD83D\uDE20";
})(FinishedQuickChatOptions || (exports.FinishedQuickChatOptions = FinishedQuickChatOptions = {}));
const getQuickChatOptions = (phase) => {
    if (!phase) {
        return null;
    }
    if (phase === game_phase_1.GamePhase.READY) {
        return ReadyQuickChatOptions;
    }
    if (phase === game_phase_1.GamePhase.PLAYING) {
        return FinishedQuickChatOptions;
    }
};
exports.getQuickChatOptions = getQuickChatOptions;
const allValues = new Set([
    ...Object.values(ReadyQuickChatOptions),
    ...Object.values(FinishedQuickChatOptions),
]);
const quickChatValueSchema = zod_1.z.custom((v) => typeof v === "string" && allValues.has(v), { message: "invalid chat value" });
exports.quickChatPlayerActionSchema = zod_1.z.object({
    sendingPlayerId: zod_1.z.string().nullable(),
    chatValue: quickChatValueSchema,
});
exports.quickChatPlayerAction = (0, api_1.networkedAction)("quickChatPlayerAction", exports.quickChatPlayerActionSchema);
exports.playerReceiveQuickChatEventSchema = zod_1.z.object({
    sendingPlayerId: zod_1.z.string(),
    chatValue: quickChatValueSchema,
});
exports.playerReceiveQuickChatEvent = (0, api_1.networkedAction)("playerReceiveQuickChatEvent", exports.playerReceiveQuickChatEventSchema);
